// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1l_hR","title":"AfterBackImages_title__lBQWg","images":"AfterBackImages_images__2bIIw"};